import Component from '@glimmer/component';
import { assert } from '@ember/debug';
import Constants from '../constants.ts';
import type { htmlSafe } from '@ember/template';
type SafeString = ReturnType<typeof htmlSafe>;

export interface AditoolsHeaderSignature {
  Element: HTMLElement;
  Args: {
    'tools-title'?: string | SafeString;
    title?: string | SafeString;
    siteURL?: string;
    locale?: string;
    logo?: string;
    suppressDropdown?: boolean;
  };
  Blocks: {
    default: [];
    footer: [];
  };
}
type AditoolsHeaderArgs = AditoolsHeaderSignature['Args'];

export default class AditoolsHeader extends Component<AditoolsHeaderSignature> {
  headerElement: HTMLElement | null = null;

  constructor(owner: unknown, args: AditoolsHeaderArgs) {
    super(owner, args);
    assert('ADI domains now use https -- check `siteURL` string', this._siteURL.startsWith('https:'));
    assert('Locale should be one of the following: en/jp/cn/ru', ['en', 'jp', 'cn', 'ru'].includes(this._locale));
  }

  // Optional parameters with defaults applied
  get _siteURL() {
    return this.args.siteURL || 'https://www.analog.com';
  }

  get _locale() {
    return this.args.locale || 'en';
  }

  get title() {
    return this.args.title ?? this.args['tools-title'] ?? '';
  }

  get logoClass() {
    return this.args.logo && this.args.logo === 'adi2'
      ? 'logo--adi2'
      : this.args.logo && this.args.logo === 'adi'
      ? 'logo--adi'
      : 'logo--awp';
  }

  get companyURL() {
    return Constants.urls.company.replace('{siteURL}', this._siteURL).replace('{loc}', this._locale);
  }

  get productsURL() {
    return Constants.urls.products.replace('{siteURL}', this._siteURL).replace('{loc}', this._locale);
  }

  get applicationsURL() {
    return Constants.urls.applications.replace('{siteURL}', this._siteURL).replace('{loc}', this._locale);
  }

  get designCenterURL() {
    return Constants.urls.designCenter.replace('{siteURL}', this._siteURL).replace('{loc}', this._locale);
  }

  get educationURL() {
    return Constants.urls.education.replace('{siteURL}', this._siteURL).replace('{loc}', this._locale);
  }

  get supportURL() {
    return Constants.urls.support.replace('{siteURL}', this._siteURL).replace('{loc}', this._locale);
  }

  get homeURL() {
    return Constants.urls.home.replace('{siteURL}', this._siteURL).replace('{loc}', this._locale);
  }
}
